<template>
  <div class="containerPage">
    <div class="w-full">
      <img src="../assets/icons/spacecraftIcon.svg" alt="Kaffea Terra spacecraft" class="w-[10vw] relative left-[5%]">
    </div>
    <Transition name="fade">
      <div class="spinTitle" v-if="isShow!==isClicked">
        <div v-if="isShow">
          {{ $t('wheelPage.title') }}
        </div>
      </div>
    </Transition>
    <Transition
      name="fade"
      @before-enter="onBeforeEnter"
      @after-leave="onAfterLeave"
    >
      <div class="lucky-wheel" v-if="isShow !== isClicked">
        <div
          class="wheel-background"
          :style="{ backgroundImage: `url(${prize_wheel}), url(${original_prize_wheel})` }"
        ></div>
        <div
          class="pointer-container"
          :class="{ 'pointer-events-none': isSpinning }"
          @click="rotateHandler"
        >
          <div
            class="pointer"
            ref="pointer"
            id="pointer"
            :style="{ transform: rotate_deg, transition: prize_transition }"
          ></div>
          <img src="@/assets/spin.svg" alt="spin" class="spin" />
        </div>
      </div>
    </Transition>

    <Transition name="fadeResult">
      <div v-if="transitionCompleted && isShow === isClicked" class="prize">
        <div class="prize-container">
          <div class="prize-title">
            <p>{{ $t('wheelPage.congratulation') }}</p>
            <p>{{ $t('wheelPage.youWon') }} {{ prize_beforeName }} {{ prize_name }}!</p>
          </div>

          <div class="prize-item" v-if="prize_name==='Promo Code 20%' || prize_name==='20% PROMO CODE'">
            {{ $t('wheelPage.emailMessage') }}
          </div>
        </div>
      </div>
    </Transition>
    <Transition name="fade" @after-enter="onFadeComplete">
      <div v-if="showEllipse && (transitionCompleted && isShow === isClicked)" class="prize-image-container">
        <Transition name="bounce">
          <img
              v-if="showPrize"
              :src="prize_image"
              :alt="prize_name"
              :class="prize_width"
          />
        </Transition>
      </div>
    </Transition>
  </div>
  <Transition name="fadeResult">
    <div v-if="transitionCompleted && isShow === isClicked" class="newRange w-full text-center p-12">
      <button type="button" @click="goToFirstStep"
              class="text-[4.5vw] text-[#101b53] bg-white focus:ring-4 focus:outline-none focus:ring-[#101b53] font-light rounded-[100vw] w-1/2 px-5 py-3 text-center uppercase">
        {{ $t('wheelPage.newRun') }}
      </button>
    </div>
  </Transition>
  <div class="flex justify-end gap-[1vw] absolute bottom-0 w-full">
    <div @click="goToPreviousStep">
      <img src="@/assets/arrowleft.svg" alt="arrow-left" class="w-[5vw] h-[5vw]">
    </div>
    <div class="opacity-[0.3]">
      <img src="@/assets/arrowright.svg" alt="arrow-right" class="w-[5vw] h-[5vw]">
    </div>
  </div>
</template>

<script>
import {sendEmail} from "@/plugins/email";
import {useRoute} from 'vue-router';

export default {
  props: {
    answers: Object,
    userInfo: {
      type: Object,
    },
  },
  data() {
    const imageUrls = {
      Brazil: "/coffees/BrazilCoffee.png",
      Colombia: "/coffees/ColombiaCoffee.png",
      Ethiopia: "/coffees/EthiopiaCoffee.png",
      Kenya: "/coffees/KenyaCoffee.png",
      India: "/coffees/IndiaCoffee.png",
      PapuaNewGuinea: "/coffees/PapuaNewGuineaCoffee.png",
    };
    const imageUrl = imageUrls[this.answers?.question2?.country] || "";
    return {
      imageUrl,
      route: useRoute(),
      rotate_deg: '0deg',
      prize_transition: 'none',
      isClicked: false,
      isShow: true,
      transitionCompleted: false,
      showEllipse: false,
      showPrize: false,
      prize_image: '',
      prize_beforeName: '',
      prize_name: '',
      prize_width: '',
      prize_wheel: null,
      original_prize_wheel: null,
      isSpinning: false,
    };
  },
  computed: {
    prizes() {
      return [
        {
          index: 1,
          beforeName: this.$t('wheelPage.prizes.mug.beforeName'),
          name: this.$t('wheelPage.prizes.mug.name'),
          imageWheel: this.route.path === '/en' ? "/wheels/englishVersion/mug.png" : "/wheels/mug.png",
          image: "/prizes/mug.png",
          weight: 1.25,
          width: 'midImageMug'
        },
        {
          index: 2,
          beforeName: this.$t('wheelPage.prizes.promo.beforeName'),
          name: this.$t('wheelPage.prizes.promo.name'),
          imageWheel: this.route.path === '/en' ? "/wheels/englishVersion/promo.png" : "/wheels/promo.png",
          image: this.route.path === '/en' ? "/prizes/englishVersion/promo.png" : "/prizes/promo.png",
          weight: 70,
          width: "midImage",
        },
        {
          index: 3,
          beforeName: this.$t('wheelPage.prizes.tshirt.beforeName'),
          name: this.$t('wheelPage.prizes.tshirt.name'),
          imageWheel: this.route.path === '/en' ? "/wheels/englishVersion/tshirt.png" : "/wheels/tshirt.png",
          image: "/prizes/tshirt.png",
          weight: 1.25,
          width: 'fullImage'
        },
        {
          index: 4,
          beforeName: this.$t('wheelPage.prizes.coffee.beforeName'),
          name: this.$t('wheelPage.prizes.coffee.name'),
          imageWheel: this.route.path === '/en' ? "/wheels/englishVersion/coffee.png" : "/wheels/coffee.png",
          image: "/prizes/coffee.png",
          weight: 10,
          width: 'smallImage'
        },
        {
          index: 5,
          beforeName: this.$t('wheelPage.prizes.toteBag.beforeName'),
          name: this.$t('wheelPage.prizes.toteBag.name'),
          imageWheel: this.route.path === '/en' ? "/wheels/englishVersion/toteBag.png" : "/wheels/toteBag.png",
          image: "/prizes/toteBag.png",
          weight: 1.25,
          width: 'fullImage'
        },
        {
          index: 6,
          beforeName: this.$t('wheelPage.prizes.capsules.beforeName'),
          name: this.$t('wheelPage.prizes.capsules.name'),
          imageWheel: this.route.path === '/en' ? "/wheels/englishVersion/capsules.png" : "/wheels/capsules.png",
          image: "/prizes/capsules.png",
          weight: 15,
          width: 'fullImage'
        },
        {
          index: 7,
          beforeName: this.$t('wheelPage.prizes.cup.beforeName'),
          name: this.$t('wheelPage.prizes.cup.name'),
          imageWheel: this.route.path === '/en' ? "/wheels/englishVersion/cup.png" : "/wheels/cup.png",
          image: "/prizes/cup.png",
          weight: 1.25,
          width: 'fullImage'
        },
      ]
    },
    routeWheel() {
      return useRoute();
    },
  },
  created() {
    this.prize_wheel = this.routeWheel.path === '/en' ? "/wheels/englishVersion/original.png" : "/wheels/original.png"
    this.original_prize_wheel = this.routeWheel.path === '/en' ? "/wheels/englishVersion/original.png" : "/wheels/original.png"
  },
  mounted() {
    this.showEllipse = true;
  },
  methods: {
    getRandomPrize() {
      const cumulativeWeights = [];
      let totalWeight = 0;

      this.prizes.forEach((prize) => {
        totalWeight += prize.weight;
        cumulativeWeights.push(totalWeight);
      });

      const randomNum = Math.random() * totalWeight;

      for (let i = 0; i < cumulativeWeights.length; i++) {
        if (randomNum <= cumulativeWeights[i]) {
          return this.prizes[i];
        }
      }
      return null; // fallback
    },
    async getUserPrize() {
      const dataForPrice = {
        email: this.userInfo.email,
        spin: true
      };
      try {
        const response = await fetch('https://kafea-terra-form-api.ocm.workers.dev/', {
          method: 'POST',
          body: JSON.stringify(dataForPrice),
          headers: {'content-type': 'application/json'}
        });

        if (!response.ok) {
          return this.getRandomPrize();
        }

        const responseIndex = await response.text();

        return this.prizes[responseIndex];
      } catch (error) {
        console.log(error)
      }
      return this.getRandomPrize();
    },

    async rotateHandler() {
      this.isSpinning = true;
      if (this.isClicked) return; // Prevent multiple clicks during spin

      const degreePerSegment = 360 / 8;
      const extraSpins = 5 * 360; // Add extra spins
      const randomPrize = await this.getUserPrize();

      // Calculate the segment for the selected prize
      const selectedSegmentIndex = randomPrize.index - 1;
      const finalDegree = extraSpins + (selectedSegmentIndex * degreePerSegment) + (degreePerSegment / 2);

      // Set rotation style
      this.rotate_deg = `rotate(${finalDegree}deg)`;
      this.prize_transition = 'transform 1.5s ease-out';

      // Set a timeout to handle after-spin actions
      setTimeout(() => {
        this.prize_wheel = randomPrize.imageWheel;

        if (randomPrize.index === 4) {
          this.prize_image = this.imageUrl;
        } else {
          this.prize_image = randomPrize.image;
        }

        this.prize_beforeName = randomPrize.beforeName;
        this.prize_name = randomPrize.name;
        this.prize_width = randomPrize.width;
        console.log(`Landed on prize: ${randomPrize.name}`);
        setTimeout(async () => {
          this.isClicked = true;
          this.isSpinning = false;
          if (randomPrize.name === 'Promo Code 20%' || randomPrize.name === '20% PROMO CODE') {
            this.sendEmail();
          }
        }, 1000); // wait for disappear wheels
      }, 3000); // Match the animation duration

    },
    sendEmail() {
      setTimeout(async () => {
        try {
          await sendEmail(this.userInfo.email);
          console.log("Email sent successfully!");
        } catch (error) {
          console.error("Failed to send email:", error.message);
        }
      }, 1000);
    },
    onBeforeEnter() {
      this.transitionCompleted = false;
    },
    onAfterLeave() {
      this.transitionCompleted = true;
    },
    onFadeComplete() {
      this.showPrize = true;
    },
    goToPreviousStep() {
      this.$emit('prev-step');
    },
    goToFirstStep() {
      this.$emit('return-home');
    },
  },
};

</script>

<style scoped>
.containerPage {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.spinTitle {
  text-align: center;
  font-size: 7vw;
  line-height: normal;
  color: #ffffff;
  background: #101b52;
  text-transform: uppercase;
}

.lucky-wheel {
  position: relative;
  display: flex;
  width: 100vw;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  z-index: 2147483646;
  padding: 0 50px;
  transition: opacity 0.8s ease-out;

  @media only screen and (max-width: 600px) {
    padding: 0 30px;
  }

  @media only screen and (max-width: 400px) {
    padding: 0 20px;
  }
}

.wheel-background {
  width: 70vw;
  height: 70vw;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.pointer-container {
  display: flex;
  width: 30vw;
  height: 30vw;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  z-index: 2147483646;
  position: absolute;
  cursor: pointer;
}

.pointer {
  width: 16.89vw;
  height: 22.65vw;
  display: block;
  background-image: url("@/assets/hand.svg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  z-index: -1;
}

.spin {
  height: 15vw;
  width: 15vw;
}

.prize {
  display: flex;
  width: 100%;
  overflow: hidden;
  margin-bottom: 1rem;
}

.prize-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.prize-title {
  text-align: center;
  font-size: 7vw;
  line-height: normal;
  color: #ffffff;
  text-transform: uppercase;
}

.prize-item {
  font-family: "CorporateFont", sans-serif;
  text-align: center;
  color: #ffffff;
  padding-bottom: 1rem;
  font-size: 5vw;
  line-height: normal;
}

.prize-image-container {
  position: relative;
  display: flex;
  width: 70vw;
  height: 70vw;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  z-index: 3;
  transform: scale(0.9);
  transition: all 0.8s ease-in-out;
  background: url("@/assets/ellipse.svg");
  background-image: url("@/assets/ellipse.svg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

img {
  z-index: 2;
}

.fullImage {
  width: 100%;
}

.midImage {
  width: 80%;
}

.smallImage {
  width: 40%;
}

.midImageMug {
  padding-left: 80px;
  width: 80%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fadeResult-enter-active,
.fadeResult-leave-active {
  transition: opacity 3s ease;
}

.fadeResult-enter-from,
.fadeResult-leave-to {
  opacity: 0;
}

.bounce-enter-active {
  animation: bounce-in 2s;
}

.bounce-leave-active {
  animation: bounce-in 2s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.arrow {
  position: absolute; /* Anchor the arrow relative to pageClass */
  bottom: 0; /* Positions the arrow at the bottom */
  left: 50%; /* Centers the arrow horizontally */
  transform: translateX(-50%); /* Adjusts alignment for perfect centering */
  width: 40px; /* Example width */
  height: 40px; /* Example height */
  background-color: black; /* Example arrow styling (can be customized) */
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%); /* Creates a triangle shape */
}

@media only screen and (max-width: 400px) {
  .newRange {
    padding: 2.5rem;

    button {
      padding: 8px 12px;
    }
  }
}
</style>
